<template>
  <component
    v-if="showRender"
    :is="`channel-${channelId}-fieldType-${fieldType}`"
    :fieldTypeInfo="fieldTypeInfo"
    :fieldInfo="fieldInfo"
    @save="handleSave"
  ></component>
</template>

<script>
import { mapActions } from 'vuex'
import job51FieldRenders from './51job'
import zhiLianFieldRenders from './zhiLian'
import liepinFieldRenders from './liepin'
import { addI18nProperty } from '@/i18n'

export default {
  components: {
    ...job51FieldRenders,
    ...zhiLianFieldRenders,
    ...liepinFieldRenders
  },
  data () {
    return {
      showRender: false,
      fieldTypeInfo: {},
      fieldInfo: {}
    }
  },
  computed: {
    channelId () {
      return this.$route.params.channelId
    },
    fieldType () {
      return this.$route.params.fieldType
    }
  },
  created () {
    this.initFieldDetailInfo()
  },
  methods: {
    ...mapActions('jobPosting', ['getPostingFieldDetail', 'savePostingField']),
    async initFieldDetailInfo () {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.getPostingFieldDetail({ channelId: this.channelId, fieldType: this.fieldType })
        if (resp) {
          addI18nProperty(resp.field_type_info, 'i18nName', 'cn_name', 'name')
          if (resp.field_type_info.channel) {
            addI18nProperty(resp.field_type_info.channel, 'i18nName', 'cn_name', 'name')
          }
          this.fieldTypeInfo = resp.field_type_info
          this.fieldInfo = resp.field_info
          this.showRender = true
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async handleSave () {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.savePostingField({ channelId: this.channelId, fieldType: this.fieldType, fieldInfo: this.fieldInfo })
        if (resp) {
          this.$router.go(-1)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
